export default "__VITE_ASSET__ff2b7e43__"